import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Fade from "react-reveal/Fade"
import { useRef } from 'react';

import classes from "./Foot1.module.css"
import logo2 from './../../Assest/ee.png';
import Heart from "./../../Assest/eziigj.gif"

import { FaHouseDamage, FaAddressCard, FaList, FaAddressBook, FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaWhatsapp } from "react-icons/fa";


const Foot = () => {


    return (
        <div className={classes.ftr} >

<Fade left>
            <div className={classes.ftr1} >

                <span className={classes.sp1}>Ready to Shape Your Future?</span>
                <br />
                <span className={classes.sp2}> Whether you’re seeking career clarity, admission guidance, exam counselling, or complete support through your academic journey, RCG (Rushikesh Career Guidance) is committed to delivering trusted, personalized, and result-oriented guidance. Because when it comes to your future, nothing less than the right direction will do. </span>

            </div>

</Fade>

<Fade right>
            <div className={classes.ftr2} >


                <div className={classes.ftr22}>

                    <div className={classes.c1}>

                        <h2 className={classes.h3}>Let’s Stay Connected </h2>

                        <div className={classes.yz}>

                           <a href="https://www.instagram.com/rcg_counselling?igsh=eG1pbGR4YXNkZXdq"> <FaInstagram className={classes.icon3} /></a>
                              <a href="https://www.facebook.com/share/1XZKZQ3v3X/">  <FaFacebook className={classes.icon3} /></a>
                               <a href="https://youtube.com/@rcg_counselling?si=sQjGAsxA-zwTwkKd"> <FaYoutube className={classes.icon3} /></a>
                              <a href="https://wa.me/+917620582520">  <FaWhatsapp className={classes.icon3} /></a>
                               <a> <FaLinkedin className={classes.icon3} /></a>



                        </div>


                        <h4 className={classes.h4}> Turning Career Confusion into Clarity</h4>

                        <div className={classes.yz}>
                            <a href='tel:+917620582520'><button className={classes.hif}>Get In Touch</button></a>
                        </div>

                    </div>


                    {/* <div className={classes.c1}>

                        <h2 className={classes.h3}> Quick links </h2>

                        <div className={classes.hu}>
                            <li><a href="/ " className={classes.apal}>Home</a></li>
                            <li><a href="/about" className={classes.apal}>About</a></li>
                            <li><a href="/service" className={classes.apal}>Services</a></li>
                            <li><a href="/Contact" className={classes.apal}>Contact Us</a></li>

                        </div>

                    </div> */}


<div className={classes.c1}>

    <h2 className={classes.h3}> Quick links </h2>

    <div className={classes.hu}>
        <li>
            <Link to="/" className={classes.apal}>
                Home
            </Link>
        </li>

        <li>
            <Link to="/about" className={classes.apal}>
                About
            </Link>
        </li>

        <li>
            <Link to="/service" className={classes.apal}>
                Services
            </Link>
        </li>

        <li>
            <Link to="/Contact" className={classes.apal}>
                Contact Us
            </Link>
        </li>
    </div>

</div>
                    
{/* 
  <div className={classes.c1}>
  <div className={classes.c1z}>
                        <h2 className={classes.h3}> Our Services</h2>
                           <div className={classes.hu}>
                            <li><a href="/service" className={classes.apal}>Medical admission Guidance </a></li>
                            <li><a href="/service" className={classes.apal}>Engineering Admission Guidance </a></li>
                            <li><a href="/service" className={classes.apal}>Mbbs abroad</a></li>
                            <li><a href="/service" className={classes.apal}>Career Assessment Test </a></li>
                            <li><a href="/service" className={classes.apal}>Career counseling</a></li>
</div>
                        

                        </div>
                    </div> */}

<div className={classes.c1}>

    <div className={classes.c1z}>

        <h2 className={classes.h3}> Our Services</h2>

        <div className={classes.hu}>

            <li>
                <Link to="/service" className={classes.apal}>
                    Medical Admission Guidance
                </Link>
            </li>

            <li>
                <Link to="/service" className={classes.apal}>
                    Engineering Admission Guidance
                </Link>
            </li>

            <li>
                <Link to="/service" className={classes.apal}>
                    MBBS Abroad
                </Link>
            </li>

            <li>
                <Link to="/service" className={classes.apal}>
                    Career Assessment Test
                </Link>
            </li>

            <li>
                <Link to="/service" className={classes.apal}>
                    Career Counseling
                </Link>
            </li>

        </div>

    </div>

</div>


                    <div className={classes.c1}>

                        <h2 className={classes.h3}> Contact Us</h2>

   <div className={classes.hu}>

<span className={classes.apal}>Pune, Maharashtra, India 411009</span>
<br/> <br/>

<p className={classes.apal32}>
<span className={classes.apal}>Email : </span>
<span className={classes.apal}><a href='mailto:help.rcginfo@gmail.com' className={classes.fd}>help.rcginfo@gmail.com</a></span>

<br/>

<span className={classes.apal}>Phone : </span>
<span className={classes.apal}><a href='tel:+917620582520' className={classes.fd}>+91 7620582520</a></span>
</p>
</div>
                    </div>


                </div>

            </div>

</Fade>

<Fade left>

<div className={classes.ftr3}>



        <div className={classes.lineContainer}>
            <span className={classes.line}></span>
            <span className={classes.text}>RUSHIKESH CAREER GUIDANCE</span>
            <span className={classes.line}></span>
        </div>
</div>

</Fade>
        </div>
    )
}


export default Foot;